import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=4de96a13&scoped=true"
import script from "./learning.vue?vue&type=script&lang=js"
export * from "./learning.vue?vue&type=script&lang=js"
import style0 from "./learning.vue?vue&type=style&index=0&id=4de96a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de96a13",
  null
  
)

export default component.exports